import { render, staticRenderFns } from "./scoreedit.vue?vue&type=template&id=4423c64d&scoped=true"
import script from "./scoreedit.vue?vue&type=script&lang=js"
export * from "./scoreedit.vue?vue&type=script&lang=js"
import style0 from "./scoreedit.vue?vue&type=style&index=0&id=4423c64d&prod&scoped=scoped&lang=css"
import style1 from "./scoreedit.vue?vue&type=style&index=1&id=4423c64d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423c64d",
  null
  
)

export default component.exports